module.exports = __webpack_public_path__ + "static/media/sg-loading-animation.d37a340b.png";